// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2C1tx","circular":"style_circular__eXsTL","rotate":"style_rotate__1M7UP","path":"style_path__3SQNO","dash":"style_dash__1Em8Q","color":"style_color__2LZNP"};